const globalStyle = {
  padding: {
    default: '2em'
  },
  pageBg: {
    background: 'linear-gradient(-45deg, rgba(246,170,48,0.8) 0%, rgba(255,100,54,0.8) 100%)',
    flex: 1,
    padding: '12px'
  },
  page: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column'
  },
  borderRadius: '4px',
  navHeight: '55px',
  colors: {
    almostWhite: '#fafafa',
    primary: 'tomato', // #ff6346
    secondary: '#40c9aa'
  },
  heading1: {
    fontSize: '2rem',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  heading2: {
    fontSize: '1.3rem'
  },
  label: {
    display: 'block',
    fontWeight: '600',
    marginBottom: '0.4em'
  },
  input: {
    width: '100%',
    fontSize: '1.1em',
    opacity: 0.8,
    padding: '0.5em 1em',
    backgroundColor: 'rgba(230, 230, 230, 0.4)',
    borderTop: 'none',
    borderRight: 'none',
    borderLeft: 'none',
    borderBottom: '3px solid rgba(220, 220, 220, 0.4)',
    outline: 'none'
  }
}

export default globalStyle



// WEBPACK FOOTER //
// ./src/globalStyle.js